import { render, staticRenderFns } from "./FreestyleAudioToggle.vue?vue&type=template&id=05a50c10&scoped=true&"
import script from "./FreestyleAudioToggle.vue?vue&type=script&lang=js&"
export * from "./FreestyleAudioToggle.vue?vue&type=script&lang=js&"
import style0 from "./FreestyleAudioToggle.vue?vue&type=style&index=0&id=05a50c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a50c10",
  null
  
)

export default component.exports